export default __webpack_public_path__ + "static/media/050_brake_tooEarly.96a71f08.mp3";